//As of date header
//row is mainLeft and mainRight(with percentSingleDecimal)
//two row gaps
import {
  renderSectionHeaderAsOfDate,
  renderMainLeftCell,
  renderMainRightCell,
  renderRowGaps
} from '../helpers';
import { percentSingleDecimal } from '../download-data-styles';

export const renderFundStatisticsRow = stat => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(stat.label);
  rowString += renderMainRightCell(stat.data, percentSingleDecimal);
  rowString += `</tr>`;
  return rowString;
};

export const fundStatisticsModule = data => {
  let fundStatisticsString = ``;
  fundStatisticsString += renderSectionHeaderAsOfDate('Fund Statistics', data.asOfDate);
  fundStatisticsString += renderRowGaps(1);
  data.data.forEach(stat => {
    fundStatisticsString += renderFundStatisticsRow(stat);
  });
  fundStatisticsString += renderRowGaps(2);
  return fundStatisticsString;
};
